/**
 * @flow
 * @relayHash 1089bf6d937d67b936b079c675300ec7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type logout_viewer$ref = any;
export type logout_QueryVariables = {| |};
export type logout_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: logout_viewer$ref,
  |},
|};
*/


/*
query logout_Query {
  viewer {
    ...logout_viewer
    id
  }
}

fragment logout_viewer on Viewer {
  id
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "logout_Query",
  "id": null,
  "text": "query logout_Query {\n  viewer {\n    ...logout_viewer\n    id\n  }\n}\n\nfragment logout_viewer on Viewer {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "logout_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "logout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "logout_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
(node/*: any*/).hash = '361f226c76aca92b9953f37cf9a0ff44';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/logout_Query.graphql.js